import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Moment from 'moment';
import Lightbox from 'react-images';
import * as actionCreators from '../../actions/sample-hardening';
import { extendMoment } from 'moment-range';
import {default as Config} from '../../config'

Moment.locale('pl')
const moment = extendMoment(Moment);

export default class Calendar extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
			lightboxIsOpen: false,
      currentDay: 1,
			currentImage: 0
		};

    this.days = this.days.bind(this)
    this.closeLightbox = this.closeLightbox.bind(this);
		this.gotoNext = this.gotoNext.bind(this);
		this.gotoPrevious = this.gotoPrevious.bind(this);
		this.gotoImage = this.gotoImage.bind(this);
		this.handleClickImage = this.handleClickImage.bind(this);
		this.openLightbox = this.openLightbox.bind(this);
    this.getImagesByDay = this.getImagesByDay.bind(this);
  }

  getImageByType(image, type = 'thumb')
  {

    let matches = image.split('.')

    return matches[0]+'_'+type+'.'+matches[1]
  }

  getImages(model, day)
  {
    let html = [];
    for(let i = 1; i <= 3; i++)
    {
      if(model['image_'+i] != null)
        html.push(<a key={i} onClick={(e) => this.openLightbox(day, (i-1), e)} href src={Config.sampleHardeningImgaesUrl+model.id+'/'+this.getImageByType(model['image_'+i], 'middle')} style={{'textAlign': 'center'}}><img src={Config.sampleHardeningImgaesUrl+model.id+'/'+this.getImageByType(model['image_'+i], 'thumb')} /></a>);
    }

    return html;
  }

  getImagesByDay(day) {

    let images = [];

    if(this.props.samples[day] != undefined){
      let model = this.props.samples[day];

      for(let i = 1; i <= 3; i++)
      {
        if(model['image_'+i] != null)
          images.push({ src: Config.sampleHardeningImgaesUrl+model.id+'/'+this.getImageByType(model['image_'+i], 'middle')});
      }
    }

    return images;
  }

  days() {
    var days = []

    let range = moment.range(
      moment(this.props.calendarDate).startOf('month').startOf('week'),
      moment(this.props.calendarDate).endOf('month').endOf('week')
    )

    let acc = Array.from(range.by('day', { step: 1 })),
        todayDay = moment().format('D'),
        todayMonth = moment().format('M')

    acc.map((day) => {
      let belongsToAsideMonth = !day.isSame(moment(this.props.calendarDate), 'month'),
          tmpModel = this.props.samples[day.format('D')]

      days.push(<li key={day.format('YYYYMMDD')} className={"day" + (belongsToAsideMonth ? ' pale' : '') + (todayDay == day.format('D') && todayMonth == day.format('M') ? ' active' : '' )}>
        <div className={"number "+(tmpModel == undefined ? 'without-images' : '')}>
          { day.format('D') }
        </div>
        <div className="list-images">
        {
          !belongsToAsideMonth ? this.props.samples[day.format('D')] != undefined ? this.getImages(this.props.samples[day.format('D')], day.format('D')) : '' : ''
        }
        </div>
      </li>)
    })

    return days;
  }

  dayHeaders() {
    var dayHeaders = []

    let range = moment.range(
      moment(this.props.calendarDate).startOf('week'),
      moment(this.props.calendarDate).endOf('week')
    )

    let acc = Array.from(range.by('day', { step: 1 }));

    acc.map((moment) => {
      dayHeaders.push(<li key={moment.format('YYYYMMDD')} className="dayHeader">{moment.format('dd')}</li>)
    })

    return dayHeaders;
  }

  openLightbox (id, index, event) {
		event.preventDefault();
		this.setState({
      currentDay: id,
			currentImage: index,
			lightboxIsOpen: true,
		});
	}

	closeLightbox () {
		this.setState({
			currentImage: 0,
			lightboxIsOpen: false,
		});
	}

	gotoPrevious () {
		this.setState({
			currentImage: this.state.currentImage - 1,
		});
	}

	gotoNext () {
		this.setState({
			currentImage: this.state.currentImage + 1,
		});
	}

	gotoImage (index) {
		this.setState({
			currentImage: index,
		});
	}

	handleClickImage () {
		if (this.state.currentImage === this.getImagesByDay(this.state.currentDay).length - 1) return;

		this.gotoNext();
	}

  render() {

    return (
      <div className="calendar">
        <ul className="days">
          {this.dayHeaders()}
          {this.days()}
        </ul>
        <Lightbox
  					currentImage={this.state.currentImage}
  					images={this.getImagesByDay(this.state.currentDay)}
  					isOpen={this.state.lightboxIsOpen}
  					onClickImage={this.handleClickImage}
  					onClickNext={this.gotoNext}
  					onClickPrev={this.gotoPrevious}
  					onClickThumbnail={this.gotoImage}
  					onClose={this.closeLightbox}
  					showThumbnails={this.props.showThumbnails}
  					spinner={this.props.spinner}
  					spinnerColor={this.props.spinnerColor}
  					spinnerSize={this.props.spinnerSize}
  					theme={this.props.theme}
            imageCountSeparator=' z '
            backdropClosesModal={true}
        />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./js/views/sample_hardening/Calendar.js
 **/